module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner"
  }, [_c('div', {
    staticClass: "dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "dot"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12219f11","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/ts/components/KkSpinner.vue
// module id = 109
// module chunks = 0